<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!--    <pre>wan: {{config.snippet.network.interface.wan.proto}} </pre> -->
        <b-row>
            <b-col sm=12>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>WAN: (External Network)</strong>
                        <!-- <pre>VEE{{ this.veeFields }}</pre> -->
                    </div>
                    <div>
                        <div>
                            <div>
                                <b-form @submit.stop.prevent="onSubmit">
                                    <b-form-group label-for="wan0_0_proto" v-if="1 > -1">
                                        <template v-slot:label>
                                            Connection Protocol:
                                        </template>
                                        <b-form-select key="WAN Protocol" v-model="config.snippet.network.interface.wan.proto" :options="protoOptions" v-validate="''" data-vv-validate-on="change" id="wan0_0_proto" name="WAN Protocol" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN Protocol') }"  :disabled=!readonly>
                                        </b-form-select>

                                    </b-form-group>
                                    <b-form-group label="IP Address:" label-for="wan0_0_ipaddr" v-if="config.snippet.network.interface.wan.proto =='static'">
                                        <b-form-input type="text" key="WAN IP Address" v-model="config.snippet.network.interface.wan.ipaddr" v-validate.initial="'ip'" id="wan0_0_ipaddr" :state="validateState('wan0_0_ipaddr')" name="WAN IP Address" class="form-control"  :disabled=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN IP Address')" class="invalid-feedback">{{ verrors.first('WAN IP Address') }}</div>
                                    </b-form-group>
                                    <b-form-group label="Netmask:" label-for="wan0_0_ipaddr" v-if="config.snippet.network.interface.wan.proto === 'static'">
                                        <b-form-input type="text" key="WAN Netmask" v-model="config.snippet.network.interface.wan.netmask" v-validate.initial="'ip'" id="wan0_0_netmask" name="WAN Netmask" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN Netmask') }"  :disabled=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN Netmask')" class="invalid-feedback">{{ verrors.first('WAN Netmask') }}</div>
                                    </b-form-group>
                                    <b-form-group label="Gateway:" label-for="wan0_0_gateway" v-if="config.snippet.network.interface.wan.proto === 'static'">
                                        <b-form-input type="text" key="WAN Gateway" v-model="config.snippet.network.interface.wan.gateway" v-validate.initial="'ip'" id="wan0_0_gateway" name="WAN Gateway" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN Gateway') }"  :disabled=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN Gateway')" class="invalid-feedback">{{ verrors.first('WAN Gateway') }}</div>
                                    </b-form-group>
                                    <b-form-group label="DNS Server:" label-for="wan0_0_dns" v-if="config.snippet.network.interface.wan.proto === 'static'">
                                        <b-form-input type="text" key="WAN DNS Server" v-model="config.snippet.network.interface.wan.dns" v-validate.initial="'ip'" id="wan0_0_dns" name="WAN DNS Server" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN DNS Server') }"  :disabled=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN DNS server')" class="invalid-feedback">{{ verrors.first('WAN DNS Server') }}</div>
                                    </b-form-group>
                                    <b-form-group label="PPPoE Username:" label-for="wan0_0_username" v-if="config.snippet.network.interface.wan.proto =='pppoe'">
                                        <b-form-input type="text" key="PPPoE Username" v-model="config.snippet.network.interface.wan.username" v-validate="" id="wan0_0_username" name="PPPoE Username" class="form-control" :class="{'is-invalid': submitted && verrors.has('PPPoE Username') }"  :disabled=!readonly></b-form-input>
                                        <div v-if="submitted && verrors.has('PPPoE Username')" class="invalid-feedback">{{ verrors.first('PPPoE Username') }}</div>
                                    </b-form-group>
                                    <b-form-group label="PPPoE Password:" label-for="wan0_0_password" v-if="config.snippet.network.interface.wan.proto =='pppoe'">
                                        <b-form-input type="text" key="PPPoE Password" v-model="config.snippet.network.interface.wan.password" v-validate="" id="wan0_0_password" name="PPPoE Password" class="form-control" :class="{'is-invalid': submitted && verrors.has('PPPoE Password') }"  :disabled=!readonly></b-form-input>
                                        <div v-if="submitted && verrors.has('PPPoE Password')" class="invalid-feedback">{{ verrors.first('PPPoE Password') }}</div>
                                    </b-form-group>
                                    <div class="text-center">
                                        <!-- TODO only activate when dirty -->
                                        <button  v-if="readonly"  :disabled="verrors.any()" class="btn btn-primary">Add</button>
                                    </div>
                                </b-form>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/configs/network/Tasks";
import IPaddress from 'ip-address';

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
        IPaddress,
    },

    props: {
        config: {
            type: Object,
            default: function () {
                return {}
            }
        },

        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },
    created() {
        this.proto_value = this.config.snippet.network.interface.wan.proto;

    },

    data() {
        return {
            loading: false,
            submitted: false,
            protoOptions: [
                { text: 'DHCP', value: "dhcp" },
                { text: 'Static', value: "static" },
                { text: 'PPPoE', value: "pppoe" },
            ],
            proto_flag: false,
            proto_value: '',
        }
    },

    methods: {

        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.verrors.has(ref)
            }
            return null
        },

        mounted() {},
        updateChanged(par, val, nam) {
            // if proto is static => unload pppoe params
            // if proto is pppoe unload static params
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this

                    // if (this.proto_value != this.device.wan0_0_proto && this.proto_flag) {
                    //   this.updateChanged("wan0_0_proto", this.device.wan0_0_proto, "WAN Protocol")
                    // } else if (this.proto_flag) {
                    //   this.updateChanged("wan0_0_proto", this.proto_value, "WAN Protocol")
                    // }

                    if (this.veeFields['WAN Protocol'].dirty) {
                        this.updateChanged("wan0_0_proto", this.config.snippet.network.interface.wan.proto, "WAN Protocol")
                    }

                    if (this.config.snippet.network.interface.wan.proto == "static") {
                        if (this.veeFields['WAN IP Address'].dirty) {
                            this.updateChanged("wan0_0_ipaddr", this.config.snippet.network.interface.wan.ipaddr, "WAN IP Address")
                            // var Address4 = require('ip-address').Address4;
                            // var myip = new Address4(this.config.snippet.network.interface.wan.ipaddr);
                            // if(myip.isValid)
                            //   console.log('Valid' );

                        }
                        if (this.veeFields['WAN Netmask'].dirty) {
                            this.updateChanged("wan0_0_netmask", this.config.snippet.network.interface.wan.netmask, "WAN Netmask")
                        }
                        if (this.veeFields['WAN Gateway'].dirty) {
                            this.updateChanged("wan0_0_gateway", this.config.snippet.network.interface.wan.gateway, "WAN Gateway")
                        }
                        if (this.veeFields['WAN DNS Server'].dirty) {
                            this.updateChanged("wan0_0_dns", this.config.snippet.network.interface.wan.dns, "WAN DNS Server")
                        }
                    } else if (this.config.snippet.network.interface.wan.proto == "pppoe") {

                        if (this.veeFields['PPPoE Username'].dirty) {
                            this.updateChanged("wan0_0_username", this.config.snippet.network.interface.wan.username, "PPPoE Username")
                        }
                        if (this.veeFields['PPPoE Password'].dirty) {
                            this.updateChanged("wan0_0_password", this.config.snippet.network.interface.wan.password, "PPPoE Password")
                        }
                    }

                    // this.$router.push("/#/devices");
                } else {
                    console.log("WAN submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('config','edit')
        },
    }
};
</script>
